import { useEnv } from '../use-env';
import { isRef, watch, onMounted, onBeforeUnmount } from 'vue-demi';

const BODY_LOCK_CLASS = 'fego-overflow-hidden';

let totalLockCount = 0;

const onTouchMove = (e) => {
    if (typeof e.cancelable !== 'boolean' || e.cancelable) {
        e.preventDefault();
    }
    e.stopPropagation();
};

/**
 * 使用锁定屏幕，一般用于弹窗
 * @param {ref} trigger 触发锁定屏幕的ref
 */
export function useLockScreen(trigger) {
    const { isPreRender } = useEnv();


    if (!isRef(trigger)) {
        throw new Error('[useLockscreen] You need to pass a ref param to this function');
    }

    if (isPreRender) {
        return;
    }

    const lock = () => {
        document.addEventListener('touchmove', onTouchMove, { passive: false });

        if (!totalLockCount) {
            document.body.classList.add(BODY_LOCK_CLASS);
        }

        totalLockCount++;
    };

    const unlock = () => {
        if (totalLockCount) {
            document.removeEventListener('touchmove', onTouchMove);

            totalLockCount--;

            if (!totalLockCount) {
                document.body.classList.remove(BODY_LOCK_CLASS);
            }
        }
    };

    watch(trigger, (val) => {
        val ? lock() : unlock();
    });

    const init = () => trigger.value && lock();
    const destroy = () => trigger.value && unlock();

    onMounted(init);
    onBeforeUnmount(destroy);
}
